import { Lista } from "./Lista";

export default Lista;